import { render, staticRenderFns } from "./PermissonUpdate.vue?vue&type=template&id=1dc42388&"
import script from "./PermissonUpdate.vue?vue&type=script&lang=js&"
export * from "./PermissonUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports